import { c as _c } from "react/compiler-runtime";
import { DateTime } from "luxon";
import { thousandize } from "../../../../util/formatting";
import styles from "./ResultsHeadline.module.scss";
export type ResultsHadlineNumbers = {
  totalDonationsToRecommendedOrgs: number;
  numberOfDonors: number;
  lastUpdated: string;
};
export interface ResultsHeadlineTextConfig {
  currencySymbol?: string;
  collectedFromDonorsText?: string;
  lastUpdatedText?: string;
  impactEstimateText?: string;
  andText?: string;
  locale?: string;
}
export const ResultsHeadline = t0 => {
  const $ = _c(55);
  const {
    headlineNumbers,
    totalOutputs,
    textConfig
  } = t0;
  let andText;
  let impactEstimateText;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== headlineNumbers.lastUpdated || $[1] !== headlineNumbers.numberOfDonors || $[2] !== headlineNumbers.totalDonationsToRecommendedOrgs || $[3] !== textConfig?.andText || $[4] !== textConfig?.collectedFromDonorsText || $[5] !== textConfig?.currencySymbol || $[6] !== textConfig?.impactEstimateText || $[7] !== textConfig?.lastUpdatedText || $[8] !== textConfig?.locale) {
    const formattedLastUpdated = DateTime.fromISO(headlineNumbers.lastUpdated).toFormat("dd.MM.yyyy HH:mm");
    const currencySymbol = textConfig?.currencySymbol || "kr";
    const collectedFromDonorsText = textConfig?.collectedFromDonorsText || "samlet inn fra {count} givere";
    const lastUpdatedText = textConfig?.lastUpdatedText || "sist oppdatert {date}";
    impactEstimateText = textConfig?.impactEstimateText || "Vi estimerer at dette har resultert i distribusjon av";
    andText = textConfig?.andText || "og";
    t5 = styles.wrapper;
    const t7 = Math.floor(headlineNumbers.totalDonationsToRecommendedOrgs);
    const t8 = textConfig?.locale;
    let t9;
    if ($[17] !== t7 || $[18] !== t8) {
      t9 = thousandize(t7, t8);
      $[17] = t7;
      $[18] = t8;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    if ($[20] !== currencySymbol || $[21] !== t9) {
      t6 = <h1>{t9}{" "}{currencySymbol}</h1>;
      $[20] = currencySymbol;
      $[21] = t9;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    t3 = styles.subheader;
    let t10;
    if ($[23] !== collectedFromDonorsText || $[24] !== headlineNumbers.numberOfDonors || $[25] !== textConfig?.locale) {
      t10 = collectedFromDonorsText.replace("{count}", thousandize(headlineNumbers.numberOfDonors, textConfig?.locale));
      $[23] = collectedFromDonorsText;
      $[24] = headlineNumbers.numberOfDonors;
      $[25] = textConfig?.locale;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    if ($[27] !== t10) {
      t4 = <p className={styles.donorcount}>{t10}</p>;
      $[27] = t10;
      $[28] = t4;
    } else {
      t4 = $[28];
    }
    t1 = styles.lastupdated;
    t2 = lastUpdatedText.replace("{date}", formattedLastUpdated);
    $[0] = headlineNumbers.lastUpdated;
    $[1] = headlineNumbers.numberOfDonors;
    $[2] = headlineNumbers.totalDonationsToRecommendedOrgs;
    $[3] = textConfig?.andText;
    $[4] = textConfig?.collectedFromDonorsText;
    $[5] = textConfig?.currencySymbol;
    $[6] = textConfig?.impactEstimateText;
    $[7] = textConfig?.lastUpdatedText;
    $[8] = textConfig?.locale;
    $[9] = andText;
    $[10] = impactEstimateText;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    andText = $[9];
    impactEstimateText = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
  }
  let t7;
  if ($[29] !== t1 || $[30] !== t2) {
    t7 = <p className={t1}>{t2}</p>;
    $[29] = t1;
    $[30] = t2;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t3 || $[33] !== t4 || $[34] !== t7) {
    t8 = <div className={t3}>{t4}{t7}</div>;
    $[32] = t3;
    $[33] = t4;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== textConfig?.locale || $[37] !== totalOutputs) {
    let t10;
    if ($[39] !== textConfig?.locale) {
      t10 = output => `${thousandize(Math.floor(output.outputs), textConfig?.locale)} ${output.name}`;
      $[39] = textConfig?.locale;
      $[40] = t10;
    } else {
      t10 = $[40];
    }
    t9 = totalOutputs.slice(0, totalOutputs.length - 1).map(t10).join(", ");
    $[36] = textConfig?.locale;
    $[37] = totalOutputs;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  const t10 = Math.floor(totalOutputs[totalOutputs.length - 1].outputs);
  const t11 = textConfig?.locale;
  let t12;
  if ($[41] !== t10 || $[42] !== t11) {
    t12 = thousandize(t10, t11);
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  const t13 = totalOutputs[totalOutputs.length - 1];
  let t14;
  if ($[44] !== andText || $[45] !== impactEstimateText || $[46] !== t12 || $[47] !== t13.name || $[48] !== t9) {
    t14 = <div className={styles.outputs}>{impactEstimateText}{" "}{t9}{" "}{andText}{" "}{t12}{" "}{t13.name}.</div>;
    $[44] = andText;
    $[45] = impactEstimateText;
    $[46] = t12;
    $[47] = t13.name;
    $[48] = t9;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== t14 || $[51] !== t5 || $[52] !== t6 || $[53] !== t8) {
    t15 = <div className={t5}>{t6}{t8}{t14}</div>;
    $[50] = t14;
    $[51] = t5;
    $[52] = t6;
    $[53] = t8;
    $[54] = t15;
  } else {
    t15 = $[54];
  }
  return t15;
};